import React, { Suspense } from "react";
import { Route } from "react-router-dom";
import { ROUTES } from "../constants/routes";
import LoaderPage from "../components/loaders/LoaderPage";
import TimeReportingHome from "../features/new_time_reporting/pages/Home";
import Components from "../features/new_time_reporting/components";
import Week from "../features/new_time_reporting/pages/Week";
import AccessHR from "../components/auth/AccessHR";
import WeekRH from "../features/new_time_reporting/pages/WeekRH";
import AnnualTracking from "../features/new_time_reporting/components/AnnualTraking";
import MyTeam from "../features/new_time_reporting/components/MyTeam";
import TimeReportingSociety from "../features/new_time_reporting/components/TimeRertingSociety";

// lazy loading
const TimeReporting = React.lazy(() =>
    import("../features/new_time_reporting")
);

/* TIME REPORTING */
export const timeReportingRoutes = (
    <Route
        path={ROUTES.time_reporting.home}
        element={
            <Suspense fallback={<LoaderPage />}>
                <TimeReporting />
            </Suspense>
        }
        key="time_reporting"
    >
        <Route index path="" element={<TimeReportingHome />} />
        <Route path="components" element={<Components />} />

        <Route path={ROUTES.time_reporting.week} element={<Week />} />
        <Route
            path={ROUTES.time_reporting.week_rh}
            element={
                <AccessHR>
                    <WeekRH />
                </AccessHR>
            }
        />
        <Route
            path={ROUTES.time_reporting.annual_tracking}
            element={<AnnualTracking />}
        />
        <Route
            path={ROUTES.time_reporting.team_tracking}
            element={<MyTeam />}
        />
        <Route
            path={ROUTES.time_reporting.entreprise}
            element={
                <AccessHR>
                    <TimeReportingSociety />
                </AccessHR>
            }
        />
    </Route>
);
